module.exports = __webpack_public_path__ + "static/media/GeraldtonGuardian-devicecomp-min.7557c046.webp";